module.exports = __webpack_public_path__ + "static/media/cifar5.ee9c2a15.png";